import React from 'react';
import playerRandomImage from '../assets/images/player_random.png';
import player2Image from '../assets/images/player_2.png';

function AICharacterButton({ type, onClick, selected }) {
  const image = type === 'random' ? playerRandomImage : player2Image;
  const name = type === 'random' ? 'Doge' : 'Casual Gamer';
  const description = type === 'random'
    ? 'Likes to confuse you with randomish moves'
    : `Can be a bully on the board, but enjoys your company`;

  return (
    <button
      onClick={onClick}
      className={`
        flex flex-col flex-1 items-center text-center py-6 px-4 rounded-lg
        transition-all duration-200
        relative overflow-hidden
        max-w-[200px]
        hover:scale-105
        ${selected
          ? 'bg-gray-800/80 scale-105 shadow-[inset_0_0_20px_rgba(255,255,255,0.1)]'
          : 'bg-gray-900/60 hover:bg-gray-800/80 hover:shadow-[inset_0_0_20px_rgba(255,255,255,0.05)]'
        }
        before:absolute before:inset-0 before:rounded-lg
        before:bg-gradient-to-b before:from-white/10 before:to-transparent
        before:opacity-0 hover:before:opacity-100
        before:transition-opacity before:duration-200
        after:absolute after:inset-0 after:rounded-lg
        after:border-2 after:border-white/20
        after:transition-all after:duration-200
        ${selected ? 'after:border-white/40 after:shadow-[0_0_15px_rgba(255,255,255,0.2)]' : ''}
      `}
    >
      <img
        src={image}
        alt={name}
        className="w-32 h-32 mt-4 object-contain drop-shadow-lg mb-3 flex-shrink-0"
      />
      <span className="text-xl font-bold text-white drop-shadow-md mb-1">{name}</span>
      <p className="text-sm text-gray-300 text-center">{description}</p>
    </button>
  );
}

export default AICharacterButton; 
